import * as echarts from "echarts";
export default {
  name: "SimpleVerticalBarChart",
  data() {
    return {};
  },
  props: {
    id: {
      type: String,
      default: 'd'
    },
    data: {
      type: Object,
      default: () => {
        return {
          x: [],
          y: []
        };
      }
    }
  },
  watch: {
    data() {
      this.renderChart();
    }
  },
  mounted() {
    this.renderChart();
  },
  unmounted() {},
  methods: {
    renderChart() {
      let option = {
        grid: {
          bottom: '0',
          left: 0,
          right: 0,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: [{
          type: 'category',
          axisTick: {
            show: false
          },
          data: this.data.x,
          axisLabel: {
            interval: 0,
            rotate: -30
          }
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          type: 'bar',
          barGap: 0,
          emphasis: {
            focus: 'series'
          },
          data: this.data.y,
          itemStyle: {
            color: '#5087EC'
          }
        }]
      };
      let bar = document.getElementById(this.id);
      let exist = echarts.getInstanceByDom(bar);
      if (exist) {
        console.log('canvas', '销毁已存在的');
        exist.dispose();
      }
      let chart = echarts.init(bar);
      chart.setOption(option);
    }
  }
};